import React, { useState } from "react";
import {
  Flex,
  Select,
  CircularProgress,
  CircularProgressLabel,
  Grid,
  Tag,
} from "@chakra-ui/react";
import FundsKPIs from "./FundsKPIs";

// Generate dummy data for each KPI
const generateMonthlyData = () => [
  { name: "Prospectus", percentage: Math.floor(70 + Math.random() * 30) },
  { name: "Commitment", percentage: Math.floor(50 + Math.random() * 30) },
  { name: "NAV reviewed", percentage: Math.floor(70 + Math.random() * 30) },
  { name: "SLA reviewed", percentage: Math.floor(60 + Math.random() * 30) },
  { name: "Approved Investors", percentage: Math.floor(60 + Math.random() * 30) },
];

// Function to calculate average data for "This quarter" and "This year" and cap each KPI at 100%
const calculateAverageData = (months) => {
  const totalData = months.reduce((acc, monthData) => {
    return acc.map((kpi, i) => ({
      ...kpi,
      percentage: kpi.percentage + monthData[i].percentage,
    }));
  }, generateMonthlyData());

  return totalData.map((kpi) => ({
    ...kpi,
    percentage: Math.min(100, Math.floor(kpi.percentage / months.length)), // Average percentage, capped at 100%
  }));
};

// Define data for "This month," "This quarter," and "This year"
const monthsData = {
  "This month": generateMonthlyData(),
  "This quarter": calculateAverageData([
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
  ]),
  "This year": calculateAverageData([
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
    generateMonthlyData(),
  ]),
};

// Function to determine progress color based on percentage
const getProgressColor = (percentage) => {
  if (percentage <= 50) return "red.400";
  if (percentage <= 74) return "yellow.400";
  return "green.400";
};

const SupervisionWidget = () => {
  const [selectedTimeframe, setSelectedTimeframe] = useState("This month");
  const data = monthsData[selectedTimeframe];

  // Handle timeframe selection change
  const handleTimeframeChange = (event) => {
    setSelectedTimeframe(event.target.value);
  };

  return (
    <Flex
      direction="column"
      flex={1}
      gap={{ lg: 8, base: 4 }}
      w={"100%"}
      gridColumn={{ lg: "span 6", base: "span 6" }}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <h5>Supervision</h5>
      </Flex>

      <Flex
        direction={{ lg: "row", base: "column" }}
        w={"100%"}
        flex={1}
        gap={{ xl: 24, lg: 16, base: 8 }}
      >
        <FundsKPIs />

        <Flex
          direction={"column"}
          gap={4}
          flex={1}
          w={"100%"}
          alignItems="center"
        >
          <Select
            position={{ lg: "absolute", base: "relative" }}
            top={{ lg: "-72px", base: "0" }}
            right={0}
            width="200px"
            onChange={handleTimeframeChange}
            value={selectedTimeframe}
          >
            {Object.keys(monthsData).map((timeframe) => (
              <option key={timeframe} value={timeframe}>
                {timeframe}
              </option>
            ))}
          </Select>

          <Grid direction="row" justifyContent="space-around" w="100%" gap={6} templateColumns={{ xl: "repeat(5, 1fr)", base: "repeat(3, 1fr)" }}>
            {data.map((kpi, index) => (
              <Flex key={index} direction="column" align="center" gap={2}>
                <CircularProgress
                  value={kpi.percentage}
                  color={getProgressColor(kpi.percentage)} // Apply color dynamically
                  size="92px"
                  thickness="8px"
                >
                  <CircularProgressLabel fontSize={"md"} fontWeight={"bold"}>{kpi.percentage}%</CircularProgressLabel>
                </CircularProgress>
                <Tag fontSize="sm" textAlign="center" fontWeight="medium">
                  {kpi.name}
                </Tag>
              </Flex>
            ))}
          </Grid>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SupervisionWidget;
